import React, { useState, useEffect } from 'react';

import {
  Box,
  Flex,
  Button,
  Text,
  Select,
  Input,
  useColorModeValue,
} from '@chakra-ui/react';

import axios from '../../utils/axios';

const initialState = {
  serviceType: '',
  serviceCreds: {
    telnyxAPI: '',
    telnyxNumber: '',
  },
};

const PhoneCredentials = () => {
  const [settings, setSettings] = useState(initialState);

  const getAllData = async () => {
    try {
      const res = await axios.get('/api/user/phone_credentials');
      setSettings(res.data);
    } catch (error) {
      console.log('Error while geeting credentials', error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  const { serviceType, serviceCreds } = settings;
  const { telnyxAPI, telnyxNumber } = serviceCreds;

  const textColor = useColorModeValue('black', 'blue.primary');
  const hoverColor = useColorModeValue('black', 'blue.primary');
  const borderColor = useColorModeValue('orange.primary', 'white.primary');
  const btnColor = useColorModeValue('orange.primary', 'white.primary');
  const btnHover = useColorModeValue('orange.secondary', 'white.secondary');

  const handleChange = (e) => {
    setSettings({
      ...settings,
      serviceCreds: { ...serviceCreds, [e.target.name]: e.target.value },
    });
  };

  const handleSubmit = async (e) => {
    console.log(settings);
    await axios.put('/api/user/phone_credentials', settings);
  };

  return (
    <Box>
      <Text fontSize="xl" fontWeight={'bold'} mb={3}>
        Phone Credentials
      </Text>
      <Select
        placeholder="Select option"
        borderColor={borderColor}
        borderRadius="12px"
        mb="24px"
        onChange={(e) =>
          setSettings({
            ...settings,
            serviceType: e.target.value,
            serviceCreds: {},
          })
        }
      >
        <option selected={serviceType == 'Telnyx' && true} value="Telnyx">
          Telnyx
        </option>
        <option selected={serviceType == 'Twilio' && true} value="Twilio">
          Twilio
        </option>
      </Select>
      {/* Sendgrid */}
      {serviceType == 'Telnyx' && (
        <Box>
          <Input
            borderRadius="15px"
            mb="24px"
            fontSize="sm"
            type="text"
            placeholder="Enter Telnyx API KEY"
            size="lg"
            borderColor={borderColor}
            name="telnyxAPI"
            defaultValue={telnyxAPI}
            id="telnyxAPI"
            onChange={handleChange}
          />
          <Input
            borderRadius="15px"
            mb="24px"
            fontSize="sm"
            type="text"
            placeholder="Enter Phone Number"
            size="lg"
            borderColor={borderColor}
            name="telnyxNumber"
            defaultValue={telnyxNumber}
            id="telnyxNumber"
            onChange={handleChange}
          />
        </Box>
      )}

      <Button
        fontSize="15px"
        type="button"
        bg={btnColor}
        w="100%"
        h="45"
        mb="20px"
        color={textColor}
        borderRadius={'12px'}
        _hover={{
          bg: btnHover,
          color: hoverColor,
        }}
        _active={{
          bg: btnHover,
          color: hoverColor,
        }}
        onClick={handleSubmit}
      >
        Save
      </Button>
    </Box>
  );
};

export default PhoneCredentials;
